const OLD_VALUE_TYPE = "oldValue";
const NEW_VALUE_TYPE = "newValue";

const mapKey = {
  [FINANCIAL_YEAR_KEY]: "Financial year",
  [LEAVE_DAY_KEY]: "Leave Day (s)",
  [LEAVE_HOUR_KEY]: "Leave Hour (s)",
  [DESCRIPTION_KEY]: "Note",
  [APPLY_DATE_KEY]: "Date Applied",
  [EXPIRE_DATE_KEY]: "Date Expired",
  [ATTACH_FILE_PATHS_KEY]: "Attach File",
  [PROJECT_KEY]: "Project",

  [WORK_SCHEDULE_CODE_KEY]: "Work Schedule",
  [WORK_SCHEDULE_TYPE_KEY]: "Work Schedule Type",
  [EXPLANATION_TIME_PER_DAYS_KEY]: "Times/ day",
  [REFUND_HOURS_PER_EXPLANATION_KEY]: "Hours/ time",
  [EXPLANATION_NUMBER_KEY]: "Times/ payroll period",
  [EXPLANATION_RULE_KEY]: "Explanation Rule",
  [OT_TYPE_KEY]: "Overtime Rule",
  [URL_POLICY_KEY]: "Policy Link",
  [POLICY_APPLY_DATE_KEY]: "Date Applied",
  [POLICY_EXPIRE_DATE_KEY]: "Date Expired",
  [EXTRA_LOYALTY_KEY]: "Extra for Loyalty",

  [CONDITION_MONTH_KEY]: "Condition/Month",
  [LEAVE_HOUR_IN_MONTH_KEY]: "Annual Hour(s)/Month",
  [ADVANCE_LEAVE_KEY]: "Payroll period(s)",

  [FROM_DATE_KEY]: "From Date",
  [TO_DATE_KEY]: "To Date",
  [DURATION_KEY]: "Duration (Hour)",
  [FROM_SHIFT_KEY]: "From Shift",
  [TO_SHIFT_KEY]: "To Shift",
  [STATUS_KEY]: "Status",
  [REASON_KEY]: "Reason for Rejection",
};
const mapValue = {
  [LEAVE_DAY_KEY]: (value) => {
    return `${value} day(s)`;
  },
  [LEAVE_HOUR_KEY]: (value) => {
    return `${value} hour(s)`;
  },
  [APPLY_DATE_KEY]: (value) => {
    return formatDateToString(value, DATE_FORMAT_V2, DATE_FORMAT_V2_FULL);
  },
  [EXPIRE_DATE_KEY]: (value) => {
    return formatDateToString(value, DATE_FORMAT_V2, DATE_FORMAT_V2_FULL);
  },
  [ATTACH_FILE_PATHS_KEY]: (value) => {
    return value?.map((item) => item.fileName) ?? [];
  },
  [POLICY_APPLY_DATE_KEY]: (value) => {
    return formatDateToString(value, DATE_FORMAT_V2, DATE_FORMAT_V2_FULL);
  },
  [POLICY_EXPIRE_DATE_KEY]: (value) => {
    return formatDateToString(value, DATE_FORMAT_V2, DATE_FORMAT_V2_FULL);
  },
  [CONDITION_MONTH_KEY]: (value) => {
    return formatDataField(value, CONDITION_MONTH_EXTRA);
  },
  [LEAVE_HOUR_IN_MONTH_KEY]: (value) => {
    return formatDataField(value, LEAVE_HOURS_IN_MONTH_EXTRA);
  },
  [ADVANCE_LEAVE_KEY]: (value) => {
    return formatDataField(value, ADVANCE_LEAVE_EXTRA);
  },
  [FROM_DATE_KEY]: (value) => {
    return formatDateToString(value, DATE_FORMAT_V2, DATE_FORMAT_V2_FULL);
  },
};

import { Clock } from "@/assets";
import {
  ADVANCE_LEAVE_EXTRA,
  ADVANCE_LEAVE_KEY,
  APPLY_DATE_KEY,
  ATTACH_FILE_PATHS_KEY,
  CONDITION_MONTH_EXTRA,
  CONDITION_MONTH_KEY,
  DESCRIPTION_KEY,
  EXPIRE_DATE_KEY,
  EXTRA_LOYALTY_KEY,
  FINANCIAL_YEAR_KEY,
  LEAVE_HOUR_IN_MONTH_KEY,
  LEAVE_DAY_KEY,
  LEAVE_HOUR_KEY,
  PROJECT_KEY,
  LEAVE_HOURS_IN_MONTH_EXTRA,
  FROM_DATE_KEY,
  TO_DATE_KEY,
  DURATION_KEY,
  FROM_SHIFT_KEY,
  TO_SHIFT_KEY,
  STATUS_KEY,
  REASON_KEY
} from "@/pages/AnnualLeave/constants";
import {
  EXPLANATION_NUMBER_KEY,
  EXPLANATION_RULE_KEY,
  EXPLANATION_TIME_PER_DAYS_KEY,
  OT_TYPE_KEY,
  POLICY_APPLY_DATE_KEY,
  POLICY_EXPIRE_DATE_KEY,
  REFUND_HOURS_PER_EXPLANATION_KEY,
  URL_POLICY_KEY,
  WORK_SCHEDULE_CODE_KEY,
  WORK_SCHEDULE_TYPE_KEY,
} from "@/pages/PolicyManagement/constants";
import { WORKING_TIME_ONSIDE_REQUEST } from "../../../commons/commonConstant";
import { DATE_FORMAT_V2, DATE_FORMAT_V2_FULL, formatDataField, formatDateToString } from "@/utils";
export default {
  name: "HistoryItem",
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  inject: ["activeId"],
  data() {
    return {
      Clock,
      mapKey,
      mapValue,
      OLD_VALUE_TYPE,
      NEW_VALUE_TYPE,
      ATTACH_FILE_PATHS_KEY,
      WORKING_TIME_ONSIDE_REQUEST
    };
  },
  methods: {
    generateValue(data, typeValue) {
      if (!data || data?.[typeValue] === undefined || data?.[typeValue] === null) {
        return "";
      }
      const { oldValue, newValue } = data;
      if (data.field === ATTACH_FILE_PATHS_KEY) {
        if (typeValue === OLD_VALUE_TYPE) {
          const oldValueCompare =
            oldValue?.filter((file) => !newValue?.find((item) => item.fileName === file.fileName)) ?? [];
          return mapValue[data.field] ? mapValue[data.field](oldValueCompare) : oldValueCompare;
        }
      }
      return mapValue[data.field] ? mapValue[data.field](data?.[typeValue]) : data?.[typeValue];
    },
  },
};
